<template>
    
    <!-- Encabezado de la aplicación -->
    <div class="appHeader">
        <div class="left">
            <a href="#" class="headerButton goBack">
                <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
        </div>
        <div class="pageTitle">
            Transacciones
        </div>
        <div class="right">
            <router-link :to="{ name: 'notifications' }" class="headerButton">
                <ion-icon class="icon" name="notifications-outline"></ion-icon>
                <span class="badge badge-danger">4</span>
            </router-link>
        </div>
    </div>
    <!-- * Encabezado de la aplicación -->


    <!-- Cápsula de la aplicación -->
    <div id="appCapsule">

        <!-- Transacciones -->
        <div class="section mt-2">
            <div class="section-title">Hoy</div>
            <div class="transactions">
                <!-- elemento -->
                <a href="app-transaction-detail.php" class="item">
                    <div class="detail">
                        <img src="@/assets/img/sample/brand/1.jpg" alt="img" class="image-block imaged w48">
                        <div>
                            <strong>Amazon</strong>
                            <p>Compras</p>
                        </div>
                    </div>
                    <div class="right">
                        <div class="price text-danger"> - $ 150</div>
                    </div>
                </a>
                <!-- * elemento -->
            </div>
        </div>
        <!-- * Transacciones -->

        <div class="section mt-2 mb-2">
            <a href="#" class="btn btn-primary btn-block btn-lg">Cargar más</a>
        </div>


    </div>
    <!-- * Cápsula de la aplicación -->



</template>

<script>
export default {
  mounted() {
    this.$root.loadBackButtom();
  }
}
</script>